import type { AttributionConfig } from './types';

const CAMPAIN_IDS = { default: '6569e30566e3190001ccb376' };
const COOKIE_DURATION = 90;
const ATTRIBUTION_LASTPAID = 'lastpaid';
const ATTRIBUTION_FIRSTCLICK = 'firstclick';

export const getAttributionConfig = (): AttributionConfig => {
  const campaignIds = CAMPAIN_IDS;
  const cookieDomain = globalThis.location.hostname;
  const cookieDuration = COOKIE_DURATION || 30;

  let lastPaidClickAttribution = false;
  let firstClickAttribution = false;
  const attribution = ATTRIBUTION_LASTPAID;
  const referrer = document.referrer;

  if (attribution === ATTRIBUTION_LASTPAID) {
    lastPaidClickAttribution = true;
  } else if (attribution === ATTRIBUTION_FIRSTCLICK) {
    firstClickAttribution = true;
  }

  return {
    campaignIds,
    cookieDomain,
    cookieDuration,
    lastPaidClickAttribution,
    firstClickAttribution,
    referrer,
  };
};
